<template>
  <div style="position: relative;background-color: #0E2038;" class="w100 minwidth mw100">
    <tabbar style="position: relative; z-index: 1;"></tabbar>

    <!-- <div>
      <carousel style="position: relative;z-index: 0; width: 100%"></carousel>
    </div> -->

    <div style="width: 100%;position: relative;">
      <img style="width: 100%;height: auto;" :src="require('../../public/img/main/picMain_2.png')" alt="">
      <!-- <div style="position: absolute;top: 55%;left: 50%;transform: translate(-50%);width: 30%;height: 4rem;line-height: 4rem;text-align: center;cursor: pointer;border: 4px solid transparent;border-radius: 16px;cursor: pointer;background-clip: padding-box, border-box;background-origin: padding-box, border-box;background-image: linear-gradient(to right, #fff, #fff), linear-gradient(90deg, #8F41E9, #578AEF);color: #5F80EA;letter-spacing: 1rem;font-size: 2rem;font-weight: bold;" @click="gotoJoin">
        获取解决方案
      </div> -->
      <div
        style="position: absolute;top: 48%;left: 50%;transform: translate(-50%);width: 35%;height: 7.5rem;line-height: 6.5rem;cursor: pointer;"
        @click="gotoJoin"></div>
    </div>


    <div style="width: 80%;margin: 0 auto;margin-top: -14rem;position: relative;z-index: 1;">
      <div style="font-size: 2.4rem;font-weight: bolder;color: #fff;text-align: center;">关于我们</div>
      <div style="font-size: 1rem;color: #fff;text-align: center;">ABOUT US</div>
      <div
        style="margin-top: 1rem;font-size: 1.2rem;line-height: 2.2rem;text-indent: 2em;text-align: justify;background-color: #f8fafc;padding: 2rem;border-radius: 1rem;">
        柿意科技平台专注为企业用户提供提供全链路战略规划与运营方案。平台为企业用户提供付费方案以及互联网、通信行业相关的付费资讯。致力于解决企业用户在公众运营与全客运营领域的关键痛点。
        <div
          style="text-align: right;font-size: 1.2rem;letter-spacing: 0.2rem;color: #5F80EA;margin-top: 1.2rem;cursor: pointer;"
          @click="gotoPartner">
          了解详情 >
        </div>
      </div>
    </div>


    <div style="width: 80%;margin: 0 auto;margin-top: 5rem;">
      <div style="font-size: 2.4rem;font-weight: bolder;color: #fff;text-align: center;">信息服务能力</div>
      <div style="font-size: 1rem;color: #999999;text-align: center;">INFORMATION SERVICE</div>
      <div style="text-align: center;font-size: 1.5rem;color: #fff;font-weight: bold;margin-top: 1rem;">
        产品与服务：整合互联网平台能力，为通信运营商提供智能信息赋能服务</div>
    </div>
    <div style="display: flex;align-items: center;justify-content: center;width: 80%;margin: 0 auto;margin-top: 5rem;"
      class="mw100">
      <div v-for="(item,index) in typeList" style="text-align: center;cursor: pointer;border-radius: 1rem;" class="w100"
        @click="typeIndex = index">
        <img style="flex: 0.25;width: 60%;" :src="index == typeIndex ? item.urlCheck : item.urlUncheck">
        <div style="color: #999999;font-size: 1.3rem;margin-top: 1rem;" :style="index == typeIndex ? 'color: #fff':''">
          {{ item.text }}</div>
      </div>
    </div>
    <div class="w100 mw100">
      <div
        style="display: flex;width: 80%;margin: 0 auto;justify-content: space-between;align-items: center;background-color: #f8fafc;margin-top: 2rem;border-radius: 1rem;">
        <div style="width: 40%;padding: 2rem;letter-spacing: 0.1rem;color: #333;">
          <div style="margin-top: 1rem;line-height: 2rem;text-align: justify;font-weight: bold;">{{
            typebtmList[typeIndex].textTop }}</div>
          <div style="margin-top: 6rem;">{{ typebtmList[typeIndex].textBtm }}</div>
        </div>
        <img style="width: 50%;border-radius: 1rem;" :src="typebtmList[typeIndex].textBg" alt="">
      </div>
    </div>

    <div style="width: 80%;margin: 0 auto;margin-top: 5rem;">
      <div style="font-size: 2.4rem;font-weight: bolder;color: #fff;text-align: center;">企业文化</div>
      <div style="font-size: 1rem;color: #999999;text-align: center;">CORPORATE CULTURE</div>
    </div>
    <div
      style="display: flex;width: 80%;margin: 0 auto;justify-content: space-around;align-items: stretch;padding-bottom: 3rem;margin-top: 2rem;">
      <div style="width: 30%;text-align: center;background-color: #f5f5f5;border-radius: 1rem;padding-top: 2rem;">
        <div style="height: 3rem;line-height: 3rem;font-size: 1.4rem;">
          企业愿景
        </div>
        <div style="margin-top: 1rem;">
          <img style="width: 100%;" :src="require(`../../public/img/partner/company1_1.png`)" alt="">
        </div>
        <div style="font-size: 1rem;width: 90%;margin: 0 auto;line-height: 2rem;margin-top: 2.5rem;">
          创新驱动，客户至上，<br>
          团队协作，共同成长。<br>
        </div>
      </div>
      <div style="width: 30%;text-align: center;background-color: #f5f5f5;border-radius: 1rem;padding-top: 2rem;">
        <div style="height: 3rem;line-height: 3rem;font-size: 1.4rem;">
          企业愿景
        </div>
        <div style="margin-top: 1rem;">
          <img style="width: 100%;" :src="require(`../../public/img/partner/company2_1.png`)" alt="">
        </div>
        <div style="font-size: 1rem;width: 90%;margin: 0 auto;line-height: 2rem;margin-top: 2.5rem;">
          成为运营商行业数字化转型的引领者，<br>
          打造移动互联网信息服务的领先品牌。
        </div>
      </div>
      <div style="width: 30%;text-align: center;background-color: #f5f5f5;border-radius: 1rem;padding-top: 2rem;">
        <div style="height: 3rem;line-height: 3rem;font-size: 1.4rem;">
          企业文化
        </div>
        <div style="margin-top: 1rem;">
          <img style="width: 100%;" :src="require(`../../public/img/partner/company3_1.png`)" alt="">
        </div>
        <div style="font-size: 1rem;width: 90%;margin: 0 auto;line-height: 2rem;padding-bottom: 1rem;margin-top: 1rem;">
          客户第一：关注需求，创造价值。<br>
          创新为本：技术领先，持续突破。<br>
          协作共赢：团队合作，共创未来。<br>
          诚信专业：用实力赢得信任。<br>
        </div>
      </div>
    </div>

    <div style="width: 80%;margin: 0 auto;margin-top: 1rem;">
      <div style="font-size: 2.4rem;font-weight: bolder;color: #fff;text-align: center;">信息服务优势</div>
      <div style="font-size: 1rem;color: #999999;text-align: center;">SERVICE ADVANTAGES</div>
    </div>
    <div style="margin-top: 2rem;color: #fff;margin-bottom: 3rem;">
      <div
        style="width: 75%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
        <!-- <div style="font-size: 3rem;color: #06d1ed;">
          01
        </div> -->
        <div>
          <div style="font-size: 1.2rem;">产品信息流推广服务解决方案</div>
          <div style="font-size: 1rem;">INFORMATION SOLUTION</div>
        </div>
      </div>
      <div style="width: 75%;margin: 0 auto;margin-top: 1rem">
        <div style="line-height: 2rem;font-size: 1.2rem;">
          <span style="font-weight: bold;font-size: 1.5rem;line-height: 3rem;">场景痛点：</span><br>
          市场竞争激烈，产品信息很容易被淹没在海量信息中，难以有效抓住目标用户的注意力。<br>
          用户对传统广告形式产生疲劳，传统推广方式转化率较低，难以提高用户的兴趣和参与度。<br>
          无法精准触达目标群体，导致推广效果不理想，资源浪费严重。<br>
        </div>
        <div style="line-height: 2rem;font-size: 1.2rem;margin-top: 1rem;">
          <span style="font-weight: bold;font-size: 1.5rem;line-height: 3rem;">服务方案：</span><br>
          智能化个性化推送：基于用户行为数据、兴趣偏好和购买历史，通过智能算法分析，精确推送符合用户需求的产品信息。<br>
          通过精准定位，确保产品信息能够在合适的时机展示给感兴趣的用户，提高点击率和转化率。
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 2rem;">
          <div style="flex: 1;">
            <img style="display: block;width: 80%;margin: 0 auto;" :src="require('../../public/img/trends/partA1.png')"
              alt="">
          </div>
          <div style="flex: 1;text-align: center">
            <img style="display: block;width: 80%;margin: 0 auto;" :src="require('../../public/img/trends/partA2.png')"
              alt="">
          </div>
          <div style="flex: 1;text-align: center">
            <img style="display: block;width: 80%;margin: 0 auto;" :src="require('../../public/img/trends/partA3.png')"
              alt="">
          </div>
        </div>
        <div style="line-height: 2rem;font-size: 1.2rem;margin-top: 1rem;">
          <span style="font-weight: bold;font-size: 1.5rem;line-height: 3rem;">成效：</span><br>
          通过精准的个性化推送和创意内容，显著提高广告的点击率和转化率，有效吸引目标用户的关注。<br>
          通过多渠道信息流分发，实现产品信息在不同平台的曝光，扩大品牌的市场覆盖。<br>
          基于数据分析和实时反馈，优化推广策略，实现高效的广告投放和资源利用，提升推广ROI。<br>
          精准的用户画像和定向推广提高了产品对潜在客户的吸引力，有效促进销售增长。<br>
        </div>
      </div>
      <div
          style="text-align: right;font-size: 1.2rem;letter-spacing: 0.2rem;color: #fff;margin-top: 1.2rem;cursor: pointer;width: 75%;margin: 0 auto;font-weight: bold;"
          @click="gotoCase">
          了解详情 >
        </div>
    </div>

    <!-- <div style="width: 80%;margin: 0 auto;margin-top: 5rem;">
      <div style="font-size: 2.4rem;font-weight: bolder;color: #111111;text-align: center;">核心业务</div>
      <div style="font-size: 1rem;color: #999999;text-align: center;">CORE BUSINESS</div>
    </div>
    <div style="margin-top: 2rem;color: #555555;margin-bottom: 3rem;">
      <div
        style="width: 80%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;">
        <div style="font-size: 3rem;color: #06d1ed;">
          01
        </div>
        <div>
          <div style="font-size: 1.2rem;">产品信息流推广服务解决方案</div>
          <div style="font-size: 1rem;">INFORMATION SOLUTION</div>
        </div>
      </div>
      <div
        style="width: 80%;margin: 0 auto;text-align: justify;line-height: 2rem;font-size: 1.2rem;margin-top: 1rem;text-indent: 2em;">
        “巨量引擎”、“腾讯广告”、“磁力引擎”、“腾讯云”等国内领先的数字化平台深度合作伙伴，面向全行业客户提供各大平台数字化咨询、合作、运营服务。公司团队敏锐洞察各行业数字化转型需求，针对不同行业匹配定制化团队，深耕于行业领域内数字化的研究，依托公司自研的数字化转型服务平台，为全行业客户业务增长赋能。
        <div
          style="text-align: center;font-size: 1.5rem;letter-spacing: 0.2rem;color: #5F80EA;margin-top: 1.2rem;cursor: pointer;"
          @click="gotoTrends">
          查看详情 >
        </div>
      </div>
      <img style="width: 80%;display: block;margin: 0 auto;margin-top: 0rem;"
        :src="require('../../public/img/main/digitize.png')" alt="">

      <div
        style="width: 80%;margin: 0 auto;letter-spacing: 0.1rem;font-weight: bolder;display: flex;justify-content: flex-start;align-items: center;margin-top: 2rem;">
        <div style="font-size: 3rem;color: #06d1ed;">
          02
        </div>
        <div>
          <div style="font-size: 1.2rem;">数字化转型支撑方案</div>
          <div style="font-size: 1rem;">SUPPORT PLAN</div>
        </div>
      </div>
      <div
        style="width: 80%;margin: 0 auto;text-align: justify;line-height: 2rem;font-size: 1.2rem;margin-top: 1rem;text-indent: 2em;">
        专注于为运营商行业提供创新的SaaS云端服务和核心算法，致力于为运营商客户提供精准的用户消费行为预测与分析解决方案。通过将决策树、因子分解机、神经网络、联邦学习等先进的机器学习算法应用于数据建模，实时评估消费者特征，柿意科技帮助运营商深入理解用户需求，优化运营策略，并推动全客运营与数字化转型的深度融合。
        凭借自主研发的技术优势，柿意科技为运营商行业提供智能化的决策支持，助力客户提升用户体验，推动业务增长，保持市场竞争力。
        <div
          style="text-align: center;font-size: 1.5rem;letter-spacing: 0.2rem;color: #5F80EA;margin-top: 1.2rem;cursor: pointer;"
          @click="gotoTrends">
          查看详情 >
        </div>
      </div>
      <img style="width: 80%;display: block;margin: 0 auto;margin-top: 0rem;"
        :src="require('../../public/img/main/intelligence.png')" alt="">
    </div> -->

    <bottom></bottom>

    <!-- <customerservice></customerservice> -->

  </div>
</template>

<script>
  import Tabbar from "../components/Tabbar.vue";
  import Bottom from "../components/Bottom.vue";
  import Carousel from "../components/Carousel.vue";

  export default {
    components: { Tabbar, Bottom, Carousel },
    data() {
      return {
        typeIndex: '0',
        typeList: [
          {
            urlCheck: require(`../../public/img/main/type1_check_2.png`),
            urlUncheck: require(`../../public/img/main/type1_check_2.png`),
            text: '推广信息服务'
          },
          {
            urlCheck: require(`../../public/img/main/type2_check_2.png`),
            urlUncheck: require(`../../public/img/main/type2_check_2.png`),
            text: '权益信息服务'
          },
          {
            urlCheck: require(`../../public/img/main/type3_check_2.png`),
            urlUncheck: require(`../../public/img/main/type3_check_2.png`),
            text: '运营信息服务'
          },
          {
            urlCheck: require(`../../public/img/main/type4_check_2.png`),
            urlUncheck: require(`../../public/img/main/type4_check_2.png`),
            text: '供应信息服务'
          }
        ],
        typebtmList: [
          {
            textTop: '与互联网大流量媒体平台合作，结合柿意自有数据平台精准触达精准用户，以数据驱动助力存量用户价值运营。',
            textBtm: '全媒体信息、数据化的精准信息、助力存量用户价值',
            textBg: require(`../../public/img/main/type1_bg_1.png`)
          },
          {
            textTop: '严苛选品，与优质供应商合作，提供包含美食、饮品、出行、阅读、生活服务等口碑极佳的品牌商品。',
            textBtm: '整合渠道、品类繁多、无忧售后',
            textBg: require(`../../public/img/main/type2_bg_1.png`)
          },
          {
            textTop: '全渠道智能客服，7*24小时及时响应，降低用户投诉率，提高满意度，构建360°视图实现全链路运营。',
            textBtm: '30+运营团队、1V1专属服务、7*24小时及时响应',
            textBg: require(`../../public/img/main/type3_bg_1.png`)
          },
          {
            textTop: '将互联网头部平台的大模型、算力等特殊能力进行行业化加工，从而定制化地提供运营商垂直行业服务解决方案。',
            textBtm: '权益商城搭建、权益内容代运营、权益体系定制方案',
            textBg: require(`../../public/img/main/type4_bg_1.png`)
          }
        ]
      };
    },

    methods: {
      skill() {
        window.scrollTo(0, 0);
        this.$router.push("/ai");
      },
      honour() {
        window.scrollTo(0, 0);
        this.$router.push("/honour");
      },

      gotoPartner() {
        this.$router.push({ path: '/partner' })
      },
      gotoTrends() {
        this.$router.push({ path: '/trends' })
      },
      gotoJoin() {
        this.$router.push({ path: '/login' })
      },
      gotoCase() {
        this.$router.push({ path: '/case' })
      }
    },
  };
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
  }

  .bgtype>>>.tabFont {
    color: #ffffff;
  }

  .bgtype>>>.tabFont:hover {
    color: rgb(233 192 131);
  }

  .bgtype>>>.tabListBut {
    color: #ffffff;
  }

  .buttype {
    background-color: transparent;
    border: 0;
  }

  a {
    text-decoration: none;
    color: #000;
  }

  .flex {
    display: flex;
  }

  .flex1 {
    flex: 1;
  }

  .flexcol {
    flex-direction: column;
  }

  .w100 {
    width: 100%;
  }

  .w80 {
    width: 80%;
  }

  .w50 {
    width: 50%;
  }

  .minwidth {
    min-width: 1000px;
  }

  .minheight {
    min-height: 200px;
  }

  .textcent {
    text-align: center;
  }

  .positionrel {
    position: relative;
  }

  .positionabs {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
  }

  .margincenter {
    margin: 0 auto;
  }

  .marginauto {
    margin: auto;
  }

  .margintop30 {
    margin-top: 30px;
  }

  .margintop70 {
    margin-top: 70px;
  }

  .marginbot20 {
    margin-bottom: 20px;
  }

  .marginbot40 {
    margin-bottom: 40px;
  }

  .fontsize14 {
    font-size: 14px;
  }

  .subtitle {
    font-size: 35px;
    font-weight: bold;
  }

  .lineheight30 {
    line-height: 30px;
  }

  .pic {
    width: 100%;
    border-radius: 10px;
  }

  .show1 {
    display: block;
  }

  .show2 {
    display: none;
  }

  .textIndent {
    text-indent: 32px;
    text-align: justify;
  }

  @media screen and (max-width: 750px) {
    .minwidth {
      min-width: 0px;
    }

    .flexnone {
      display: block;
    }

    .mw100 {
      width: 100vw;
    }

    .show1 {
      display: none;
    }

    .show2 {
      display: block;
    }
  }
</style>